export default __webpack_public_path__ + "static/media/holiday_banner.7f9e3918.svg";